import React, { useEffect, useState } from "react";
import { Link } from "../general";
import { useLocation, useNavigate } from "react-router";

export interface VerticalNavbarProps {}

const VerticalNavbar: React.FC<VerticalNavbarProps> = (props) => {
  const location = useLocation();
  const [experienceExpanded, setExperienceExpanded] = useState(false);
  const [projectsExpanded, setProjectsExpanded] = useState(false);
  const [isHome, setIsHome] = useState(false);

  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact");
  };

  useEffect(() => {
    if (location.pathname.includes("/projects")) {
      setProjectsExpanded(true);
    } else {
      setProjectsExpanded(false);
    }
    if (location.pathname.includes("/experience")) {
      setExperienceExpanded(true);
    } else {
      setExperienceExpanded(false);
    }
    if (location.pathname === "/") {
      setIsHome(true);
    } else {
      setIsHome(false);
    }
    return () => {};
  }, [location.pathname]);

  return !isHome ? (
    <div style={styles.navbar}>
      <div style={styles.header}>
        <h1 style={styles.headerText}>Jonas</h1>
        <h1 style={styles.headerText}>Kjeldmand</h1>
        <h1 style={styles.headerText}>Jensen</h1>
        <h3 style={styles.headerShowcase}>Selected Works 2022-2026</h3>
      </div>
      <div style={styles.links}>
        <Link containerStyle={styles.link} to="" text="HOME" />
        <Link containerStyle={styles.link} to="about" text="ABOUT ME" />
        <Link
          containerStyle={Object.assign(
            {},
            styles.link,
            experienceExpanded && styles.expandedLink
          )}
          to="experience"
          text="EXPERIENCE"
        />
        {experienceExpanded && (
          <div style={styles.insetLinks}>
            <Link
              containerStyle={styles.insetLink}
              to="experience/papers"
              text="Research Papers"
            />
            <Link
              containerStyle={styles.insetLink}
              to="experience/practitioner-articles"
              text="Practitioner Articles & Workshops"
            />
          </div>
        )}

        <Link
          containerStyle={Object.assign(
            {},
            styles.link,
            projectsExpanded && styles.expandedLink
          )}
          to="projects"
          text="PROJECTS & SELECTED WORKS"
        />
        {projectsExpanded && (
          <div style={styles.insetLinks}>
            <Link
              containerStyle={styles.insetLink}
              to="projects/software"
              text="Coding & Programming"
            />
            <Link
              containerStyle={styles.insetLink}
              to="projects/art"
              text="Embedded Computing"
            />
            <Link
              containerStyle={styles.insetLink}
              to="projects/music"
              text="Music & Art"
            />
          </div>
        )}
        <Link containerStyle={styles.link} to="contact" text="CONTACT" />
      </div>
      <div style={styles.spacer} />
      <div style={styles.forHireContainer} onMouseDown={goToContact} />
    </div>
  ) : (
    <></>
  );
};

const styles: StyleSheetCSS = {
  navbar: {
    width: 300,
    height: "100%",
    flexDirection: "column",
    padding: 48,
    boxSizing: "border-box",
    position: "fixed",
    overflow: "hidden",
  },
  header: {
    flexDirection: "column",
    marginBottom: 64,
  },
  headerText: {
    fontSize: 38,
    lineHeight: 1,
  },
  headerShowcase: {
    marginTop: 12,
  },
  logo: {
    width: "100%",
    marginBottom: 8,
  },
  link: {
    marginBottom: 32,
  },
  expandedLink: {
    marginBottom: 16,
  },
  insetLinks: {
    flexDirection: "column",
    marginLeft: 32,
    marginBottom: 16,
  },
  insetLink: {
    marginBottom: 8,
  },
  links: {
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
  },
  image: {
    width: "80%",
  },
  spacer: {
    flex: 1,
  },
  forHireContainer: {
    cursor: "pointer",
    width: "100%",
  },
};

export default VerticalNavbar;
